import { Entity, type EnemyConstruction } from "../Entity";

/** Authored boss behavior layered over the shared movement and damage mechanics. */
export class BossEntity extends Entity {
  constructor(init: EnemyConstruction) {
    super(init);
  }

  override get isBoss(): boolean {
    return true;
  }

  override get usesLargeEffects(): boolean {
    return true;
  }

  override get keepsFacingSheet(): boolean {
    return true;
  }

  protected override resetRollAnimation(_destroyed: number): number {
    super.resetRollAnimation(0);
    return 6;
  }

  protected override updateRollingBehavior(returnAction: number): number {
    if (!this.enemyData.stopper || this.rollData.rollCounter !== 5) {
      return returnAction;
    }
    if (this.rollData.alternate) returnAction = 15;
    this.rollData.alternate = !this.rollData.alternate;
    return returnAction;
  }

  protected override updateBossEvent(mode: number): void {
    switch (mode) {
      case 0:
        this.enemyData.stopper = true;
        this.setActionLimit(0);
        this.actionCounter = 0;
        this.enemyData.speedNormal = 3;
        this.baseSpeed = this.enemyData.speedNormal;
        break;
      case 1:
        this.enemyData.stopper = false;
        this.actionCounter = 0;
        this.moving = false;
        this.xSpeed = 0;
        this.ySpeed = 0;
        this.xTarget = this.xPos;
        this.yTarget = this.yPos;
        break;
    }
  }
}
